var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 12,
    viewBox: "0 0 53 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1165_19382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5823 1.0094H21.5542L24.9073 7.17994L28.2603 1.0094H30.1896V11.1487H28.5807V3.3777L25.6406 8.7588H24.1313L21.1912 3.3777V11.1487H19.5823V1.0094Z",
    fill: "#1C2B33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3792 11.3299C34.634 11.3299 33.9791 11.1621 33.4144 10.8265C32.8495 10.491 32.4093 10.0262 32.0938 9.43236C31.7781 8.83846 31.6203 8.15767 31.6204 7.39C31.6204 6.61269 31.7746 5.92466 32.0831 5.32591C32.3916 4.72729 32.8199 4.25893 33.3681 3.92084C33.9163 3.58296 34.5463 3.41397 35.2582 3.41388C35.9653 3.41388 36.574 3.58407 37.0842 3.92444C37.5943 4.26491 37.987 4.74172 38.2624 5.35486C38.5376 5.96809 38.6752 6.68751 38.6753 7.51311V7.96207H33.215C33.3147 8.58021 33.5603 9.06666 33.9519 9.42144C34.3434 9.77634 34.8382 9.95377 35.4361 9.95374C35.9155 9.95374 36.3284 9.88132 36.6749 9.73647C37.0212 9.59163 37.3464 9.37196 37.6502 9.07746L38.5044 10.1421C37.6548 10.934 36.6131 11.3299 35.3792 11.3299ZM36.5538 5.31499C36.2168 4.965 35.7754 4.78997 35.2297 4.78991C34.6981 4.78991 34.2532 4.96857 33.8949 5.32591C33.5365 5.68321 33.3099 6.16362 33.215 6.76715H37.1305C37.083 6.1491 36.8908 5.66505 36.5538 5.31499Z",
    fill: "#1C2B33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.626 4.93486H39.1453V3.595H40.626V1.37885H42.178V3.595H44.4275V4.93486H42.178V8.33151C42.178 8.89637 42.2729 9.29952 42.4627 9.54096C42.6525 9.78246 42.9776 9.90317 43.438 9.90307C43.642 9.90307 43.8152 9.89463 43.9577 9.87773C44.1001 9.8609 44.2567 9.83796 44.4275 9.80891V11.1343C44.2326 11.1916 44.034 11.2352 43.8331 11.2647C43.6033 11.2991 43.3713 11.316 43.139 11.3154C41.4636 11.3154 40.626 10.3835 40.626 8.51983V4.93486Z",
    fill: "#1C2B33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.515 11.1488H50.9916V10.0914C50.721 10.4873 50.377 10.7927 49.9593 11.0075C49.5416 11.2223 49.067 11.3297 48.5355 11.3299C47.8806 11.3299 47.3004 11.1597 46.7949 10.8192C46.2895 10.4788 45.892 10.0105 45.6025 9.41423C45.313 8.81793 45.1682 8.13594 45.1682 7.36827C45.1682 6.59576 45.3153 5.91254 45.6096 5.31861C45.9038 4.7248 46.3108 4.25887 46.8305 3.92084C47.3502 3.58296 47.947 3.41397 48.6209 3.41388C49.1287 3.41388 49.5844 3.51408 49.9878 3.71449C50.3857 3.91033 50.7304 4.20252 50.9916 4.56543V3.59498H52.515V11.1488ZM50.9631 6.23845C50.7969 5.80873 50.5347 5.46952 50.1764 5.22083C49.818 4.97221 49.4039 4.8479 48.9342 4.8479C48.2697 4.8479 47.7405 5.07482 47.3467 5.52865C46.9527 5.98252 46.7557 6.59572 46.7558 7.36826C46.7558 8.14567 46.9456 8.76128 47.3253 9.21509C47.7049 9.66896 48.2199 9.89588 48.8701 9.89585C49.3494 9.89585 49.7765 9.7703 50.1515 9.51921C50.5264 9.26827 50.7969 8.9303 50.9631 8.50529L50.9631 6.23845Z",
    fill: "#1C2B33"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1165_19382)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1165_19382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.0186 0.666687C5.01353 0.666687 5.00848 0.666705 5.00341 0.666732L4.98267 2.41022C4.98741 2.41017 4.99216 2.41013 4.99691 2.41013H4.99692C6.12495 2.41013 6.99992 3.31496 8.90167 6.5738L9.0176 6.77219L9.02518 6.78518L10.0898 5.16019L10.0824 5.14764C9.83185 4.7331 9.59116 4.3517 9.36033 4.00343C9.09262 3.59991 8.8366 3.23943 8.58814 2.91758C7.33008 1.28798 6.27769 0.666687 5.0186 0.666687Z",
    fill: "url(#paint0_linear_1165_19382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00341 0.666732C3.73822 0.673354 2.6197 1.50566 1.81202 2.77926C1.80966 2.78298 1.8073 2.78672 1.80493 2.79046L3.2875 3.61139C3.28991 3.60768 3.29233 3.60396 3.29474 3.60027C3.76638 2.87785 4.3533 2.41709 4.98267 2.41023C4.98742 2.41017 4.99216 2.41013 4.99691 2.41013L5.0186 0.666687C5.01353 0.666687 5.00848 0.666705 5.00341 0.666732Z",
    fill: "url(#paint1_linear_1165_19382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.81204 2.77924C1.80967 2.78296 1.80731 2.7867 1.80494 2.79044C1.27422 3.63093 0.878573 4.66231 0.664756 5.77498C0.66383 5.7798 0.662907 5.78462 0.661987 5.78944L2.3276 6.18926C2.32847 6.18443 2.32934 6.17959 2.33022 6.17476C2.50825 5.19691 2.8472 4.28999 3.28751 3.61137C3.28991 3.60766 3.29233 3.60394 3.29475 3.60025L1.81204 2.77924Z",
    fill: "url(#paint2_linear_1165_19382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33026 6.17474L0.664796 5.77496C0.66387 5.77978 0.662947 5.7846 0.662027 5.78942C0.545436 6.40134 0.48612 7.02312 0.484875 7.64643C0.484866 7.65147 0.484862 7.65651 0.484864 7.66154L2.19301 7.81701C2.19288 7.81195 2.19274 7.80695 2.19262 7.80188C2.19178 7.76573 2.19135 7.72909 2.19134 7.69195C2.19219 7.18789 2.23781 6.68494 2.32764 6.18923C2.32851 6.18441 2.32938 6.17957 2.33026 6.17474Z",
    fill: "url(#paint3_linear_1165_19382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.24496 8.35923C2.21432 8.18009 2.19695 7.99885 2.193 7.81706C2.19287 7.812 2.19273 7.80701 2.19261 7.80193L0.484875 7.64648C0.484866 7.65152 0.484862 7.65656 0.484864 7.6616V7.66258C0.484864 8.0505 0.516663 8.41372 0.578464 8.74925C0.579357 8.75411 0.580236 8.75887 0.581143 8.76372L2.24754 8.37374C2.24666 8.36893 2.24581 8.36407 2.24496 8.35923Z",
    fill: "url(#paint4_linear_1165_19382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.63416 9.25861C2.44828 9.0522 2.31674 8.75448 2.24758 8.37371C2.2467 8.36889 2.24585 8.36404 2.245 8.35919L0.578491 8.74922C0.579385 8.75407 0.580263 8.75884 0.58117 8.76368C0.707131 9.43648 0.954162 9.9972 1.30793 10.4214C1.31108 10.4252 1.31423 10.4289 1.3174 10.4327L2.64408 9.26948C2.64077 9.26588 2.63744 9.26225 2.63416 9.25861Z",
    fill: "url(#paint5_linear_1165_19382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57124 4.43585C6.567 6.00289 5.95864 6.98576 5.95864 6.98576C4.62091 9.11909 4.15813 9.59723 3.41334 9.59723C3.10256 9.59723 2.84292 9.48466 2.64402 9.26947C2.6407 9.26588 2.63737 9.26225 2.63409 9.2586L1.30786 10.4214C1.31101 10.4252 1.31416 10.4289 1.31733 10.4327C1.8058 11.0119 2.49529 11.3333 3.34826 11.3333C4.63875 11.3333 5.56687 10.7144 7.21683 7.78024C7.21683 7.78024 7.90464 6.54459 8.37781 5.69341C8.08471 5.21199 7.81798 4.79521 7.57124 4.43585Z",
    fill: "#0082FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36126 1.96246C9.35787 1.96612 9.35442 1.96986 9.35104 1.97352C9.08732 2.25937 8.83423 2.57858 8.58801 2.91726C8.83648 3.23911 9.09297 3.60029 9.36068 4.00381C9.67621 3.50838 9.97072 3.10712 10.2594 2.79957C10.2628 2.79592 10.2662 2.79238 10.2696 2.78876L9.36126 1.96246Z",
    fill: "url(#paint6_linear_1165_19382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2366 1.80884C13.5363 1.08904 12.7012 0.666687 11.8085 0.666687C10.8672 0.666687 10.0754 1.19148 9.36117 1.96245C9.35779 1.96611 9.35434 1.96985 9.35095 1.97351L10.2593 2.79956C10.2627 2.79591 10.2661 2.79237 10.2695 2.78875C10.74 2.29089 11.1953 2.04232 11.7 2.04232H11.7C12.2433 2.04232 12.7519 2.30249 13.1923 2.75859C13.1958 2.76217 13.1992 2.76571 13.2027 2.76931L14.2471 1.81956C14.2436 1.81597 14.2401 1.81242 14.2366 1.80884Z",
    fill: "#0082FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2614 7.41699C16.2221 5.10585 15.4271 3.0397 14.2471 1.81955C14.2436 1.81596 14.2401 1.81241 14.2367 1.80884L13.1924 2.75858C13.1958 2.76216 13.1993 2.7657 13.2027 2.7693C14.0904 3.69697 14.6993 5.42245 14.7547 7.4165C14.7548 7.42151 14.755 7.42653 14.7551 7.43156L16.2616 7.43205C16.2615 7.42704 16.2614 7.42202 16.2614 7.41699Z",
    fill: "url(#paint7_linear_1165_19382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2615 7.43206C16.2614 7.42704 16.2614 7.42202 16.2613 7.417L14.7546 7.4165C14.7548 7.42152 14.7549 7.42654 14.7551 7.43156C14.7575 7.52515 14.7587 7.61931 14.7587 7.71403C14.7587 8.2577 14.6789 8.69719 14.5166 9.01448C14.5142 9.01919 14.5117 9.02391 14.5093 9.02856L15.6326 10.2171C15.6354 10.2128 15.6381 10.2085 15.6409 10.2041C16.0487 9.564 16.2628 8.67472 16.2628 7.59633C16.2628 7.54144 16.2624 7.48668 16.2615 7.43206Z",
    fill: "url(#paint8_linear_1165_19382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5167 9.01447C14.5143 9.01917 14.5118 9.0239 14.5094 9.02855C14.3689 9.296 14.1684 9.47438 13.9062 9.55239L14.4184 11.1942C14.4862 11.1708 14.5522 11.1445 14.6164 11.1153C14.6356 11.1066 14.6546 11.0977 14.6735 11.0885C14.6844 11.0832 14.6952 11.0778 14.706 11.0724C15.0446 10.9007 15.3307 10.6474 15.5621 10.3212C15.5763 10.3013 15.5903 10.2812 15.604 10.2607C15.6137 10.2463 15.6232 10.2318 15.6327 10.2171C15.6355 10.2128 15.6382 10.2085 15.641 10.2041L14.5167 9.01447Z",
    fill: "url(#paint9_linear_1165_19382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5803 9.59725C13.4086 9.59725 13.257 9.57124 13.1088 9.50385L12.5845 11.1848C12.8792 11.2872 13.1935 11.3334 13.5441 11.3334C13.8671 11.3334 14.1636 11.2841 14.4324 11.1894L13.9205 9.5481C13.8101 9.58173 13.6955 9.5983 13.5803 9.59725V9.59725Z",
    fill: "url(#paint10_linear_1165_19382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5309 9.02238C12.5277 9.01859 12.5244 9.01477 12.5212 9.01093L11.3147 10.2874C11.3181 10.2911 11.3214 10.2948 11.3248 10.2984C11.744 10.7529 12.1443 11.0349 12.5983 11.1896L13.1223 9.50993C12.9309 9.42634 12.7459 9.2748 12.5309 9.02238Z",
    fill: "url(#paint11_linear_1165_19382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5212 9.01091C12.1593 8.58277 11.7116 7.86993 11.0074 6.71722L10.0897 5.16019L10.0824 5.14764L9.01758 6.77219L9.02517 6.78518L9.6754 7.89798C10.3057 8.971 10.8192 9.74726 11.3147 10.2874C11.3181 10.2911 11.3214 10.2948 11.3248 10.2984L12.5309 9.02236C12.5277 9.01858 12.5244 9.01476 12.5212 9.01091Z",
    fill: "url(#paint12_linear_1165_19382)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1165_19382",
    x1: 9.38214,
    y1: 6.12434,
    x2: 5.77062,
    y2: 1.47261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006,
    stopColor: "#0867DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4539,
    stopColor: "#0668E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    stopColor: "#0064E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1165_19382",
    x1: 2.50132,
    y1: 3.07222,
    x2: 4.95469,
    y2: 1.24137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1323,
    stopColor: "#0064DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    stopColor: "#0064E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1165_19382",
    x1: 1.4743,
    y1: 5.8185,
    x2: 2.4755,
    y2: 3.34112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0147,
    stopColor: "#0072EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6881,
    stopColor: "#0064DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1165_19382",
    x1: 1.34234,
    y1: 7.61669,
    x2: 1.45872,
    y2: 6.09678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0731,
    stopColor: "#007CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    stopColor: "#0072EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1165_19382",
    x1: 1.40419,
    y1: 8.4425,
    x2: 1.32098,
    y2: 7.8338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0731,
    stopColor: "#007FF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007CF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1165_19382",
    x1: 1.357,
    y1: 8.60245,
    x2: 1.8726,
    y2: 9.67741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0731,
    stopColor: "#007FF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1165_19382",
    x1: 9.06271,
    y1: 3.36811,
    x2: 9.74055,
    y2: 2.44659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2799,
    stopColor: "#007FF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9141,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1165_19382",
    x1: 14.102,
    y1: 2.15943,
    x2: 15.5336,
    y2: 7.33606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#0081FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1165_19382",
    x1: 15.8233,
    y1: 7.54703,
    x2: 14.9213,
    y2: 9.33875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0619,
    stopColor: "#0081FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0080F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1165_19382",
    x1: 14.2485,
    y1: 10.3075,
    x2: 15.0776,
    y2: 9.75238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027AF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0080F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1165_19382",
    x1: 12.962,
    y1: 10.4186,
    x2: 14.1019,
    y2: 10.4186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0377EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "#0279F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1165_19382",
    x1: 11.9709,
    y1: 9.77996,
    x2: 12.7975,
    y2: 10.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0019,
    stopColor: "#0471E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0377EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1165_19382",
    x1: 9.47107,
    y1: 6.1633,
    x2: 12.1517,
    y2: 9.4762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2765,
    stopColor: "#0867DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0471E9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1165_19382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.9327,
    height: 10.3205,
    fill: "white",
    transform: "translate(19.5823 1.0094)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1165_19382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.778,
    height: 10.6667,
    fill: "white",
    transform: "translate(0.484863 0.666687)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1165_19382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.778,
    height: 10.6667,
    fill: "white",
    transform: "translate(0.484863 0.666687)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta);
export default __webpack_public_path__ + "static/media/meta.5c1d88c5d04223effff596d4fe467064.svg";
export { ForwardRef as ReactComponent };